import React from 'react';
import { History } from 'lucide-react';
import { Badge } from '../ui/badge';

const OUTCOME_STYLES = {
  won: 'bg-emerald-100 text-emerald-800',
  lost: 'bg-rose-100 text-rose-800',
};

const formatDate = (value) => (value ? new Date(value).toLocaleDateString('en-IN') : '—');

export const lastQuoteRate = (lastQuote) =>
  Number(lastQuote?.unit_price_inr ?? lastQuote?.unit_price ?? 0) || 0;

/** Previous quoted rate for a part, with a green/red comparison when a new rate is supplied. */
export const LastQuoteChip = ({ lastQuote, newRate, testId }) => {
  if (!lastQuote) {
    return (
      <span className="text-xs text-muted-foreground" data-testid={testId ? `${testId}-none` : undefined}>
        No earlier quote
      </span>
    );
  }
  const previous = lastQuoteRate(lastQuote);
  const current = Number(newRate || 0);
  const showDelta = previous > 0 && current > 0;
  const deltaPercent = showDelta ? ((current - previous) / previous) * 100 : 0;
  const higher = deltaPercent > 0;

  return (
    <div className="space-y-1 text-xs" data-testid={testId}>
      <div className="flex flex-wrap items-center gap-1">
        <History className="h-3 w-3 text-muted-foreground" />
        <span className="font-mono font-medium">
          ₹{previous.toFixed(4)}/{lastQuote.unit === 'kg' ? 'kg' : 'pc'}
        </span>
        <Badge variant="outline" className={OUTCOME_STYLES[lastQuote.outcome] || 'bg-slate-100 text-slate-700'}>
          {lastQuote.outcome}
        </Badge>
      </div>
      <p className="text-muted-foreground">
        {lastQuote.quotation_number} · {formatDate(lastQuote.quoted_at)}
      </p>
      {showDelta && Math.abs(deltaPercent) >= 0.01 && (
        <p
          className={`font-medium ${higher ? 'text-emerald-700' : 'text-rose-700'}`}
          data-testid={testId ? `${testId}-delta` : undefined}
        >
          {higher ? '+' : ''}{deltaPercent.toFixed(1)}% vs last quote
        </p>
      )}
    </div>
  );
};
